import { SEOSegmentationSearchingFor } from '@/__generated__/globalTypes';
import { GAMTargetingRules, PageTemplate } from '@/types/common';

/*
 * This function returns the GAM content type based on the page template and/or searchingFor value.
 *
 * @param searchingFor - The searchingFor value from SEOSegmentationSearchingFor
 * @param pageTemplate - The page template value from PageTemplate
 * @returns The GAM content type.
 */

const getGAMContentType = ({
  searchingFor,
  pageTemplate,
}: {
  searchingFor?: string;
  pageTemplate?: PageTemplate;
}): GAMTargetingRules['contType'] => {
  if (pageTemplate === PageTemplate.COST_GUIDE) {
    return 'none';
  }

  if (
    searchingFor === SEOSegmentationSearchingFor.ALL_JOB ||
    searchingFor === SEOSegmentationSearchingFor.SEEKER_JOB ||
    searchingFor === SEOSegmentationSearchingFor.SMB_JOB
  ) {
    return 'seeker';
  }

  return 'provider';
};

export { getGAMContentType };
